// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
        reduceMinMatch: 2,
        enableFuzzy: false
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
};


// Build Pages
BCSfFilter.prototype.buildSuggestionPage = function(searchTerm, itemData, ul, itemInfo, suggestionData) {
    var result = '';
    if (Object.keys(itemData).length > 0) {
        // Build content
        var result = this.buildSuggestionHeader(itemInfo['label'], 'page');
        for (var k in itemData) {            
            if(itemData[k].url.indexOf('/blogs/shoppable-images/') !== 0){
                // if (k < itemInfo['number']) {
                    var searchResult = this.highlightSuggestionResult(itemData[k]['title'], searchTerm);
                    result += '<li class="' + this.class.searchSuggestionItem + '" aria-label="' + this.escape(itemInfo['label']) + ': ' + this.escape(itemData[k]['title']) + '">';
                    result += '<a href="' + itemData[k]['url'] + '">' + searchResult + '</a>';
                    result += '</li>';
                // }
            }
        }
    }
    return result;
}

